import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";

import { clearPbxData } from "@/store/reducers/root";

import { Box, LinearProgress } from "@mui/material";

import AppBarContainer from "./navigation/AppBar";
import DialDrawer from "./navigation/DialDrawer";
import MenuDrawer from "./navigation/MenuDrawer";

export default function CoreUI() {
  const location = useLocation();
  const dispatch = useDispatch();

  const drawerExpanded = useSelector((state) => state.ui.drawerExpanded);
  const dialDrawer = useSelector((state) => state.ui.dialDrawer);
  const progressBar = useSelector((state) => state.ui.progressBar);

  useEffect(() => {
    if (location.pathname === "/backstage") {
      dispatch(clearPbxData());
    }
  }, [location.pathname, dispatch]);

  return (
    <>
      {progressBar && (
        <LinearProgress
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: (theme) => theme.zIndex.drawer + 10,
            width: 1,
            background: "transparent",
            height: 3,
          }}
        />
      )}
      <Box
        sx={(theme) => ({
          display: "grid",
          height: "100dvh",
          gridTemplateColumns: {
            xs: "100vw",
            lg: `calc(${drawerExpanded ? 32 : 7} * 8px) calc(100vw - ${
              drawerExpanded ? (dialDrawer ? 64 : 32) : dialDrawer ? 39 : 7
            } * 8px) ${dialDrawer ? "256px" : "0"}`,
          },
          gridTemplateRows: "auto",
          gridTemplateAreas: { xs: "'content'", lg: "'navigation content dial'" },
          gap: 0,
          ...theme.scrollbar,
        })}
      >
        <MenuDrawer />
        <Box sx={{ gridArea: "content", overflow: "auto", maxHeight: "100dvh" }} className="@container/outlet">
          <AppBarContainer />
          <Box sx={{ position: "relative" }}>
            <Outlet />
          </Box>
        </Box>
        <DialDrawer />
      </Box>
    </>
  );
}
